import React, { FC, useEffect, useState } from 'react';

import Layout from '../../Layout';
import VideoComponent from '../../shared/VideoComponent';
import ButtonCTA from '../../shared/buttonComponents/ButtonCTA';
import SocialIcon from '../../shared/SocialIcon';
import EmailIcon from '../../shared/svg/EmailIcon';
import InstagramIcon from '../../shared/svg/InstagramIcon';
import FacebookIcon from '../../shared/svg/FacebookIcon';
import TwitterIcon from '../../shared/svg/TwitterIcon';
import LinkedInIcon from '../../shared/svg/LinkedInIcon';
import WhatsAppIcon from '../../shared/svg/WhatsAppIcon';
import { getWizardState } from '../../../storage/wizard-state';
import ButtonDownload from '../../shared/buttonComponents/ButtonDownload';
import { useMediaQuery } from '../../../contexts/MediaQueryContext';


export const ThankYouPage: FC = () => {
  const wizardStorage = getWizardState();
  const { onMobile } = useMediaQuery();

  let title = '';

  if (wizardStorage.data.approvedProposal === 'not-approved') {
    title = 'One of our representatives will contact you soon.';
    // setShowDownloadButton(true)
  } else if ((wizardStorage.data.approvedProposal === 'approved')) {
    title = 'Our team will send you the price proposal via email.';
    // setShowDownloadButton(false)
  } else {
    title = 'One of our representatives will contact you soon.';
  }

  const [activateChat, setActivateChat] = useState(false);


  useEffect(() => {
    if (onMobile) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'scriptID';
      script.innerHTML = `
      window.__lc = window.__lc || {};
      window.__lc.license = 6869171;
      (function () {
        var lc = document.createElement('script');
        lc.type = 'text/javascript';
        lc.async = true;
        lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(lc, s);
      })();
    `;
      document.body.appendChild(script);

      const chat = document.createElement('div');
      chat.className = 'new_chat';
      chat.id = 'chatID';
      chat.innerHTML = `
      <img id="liveagent_button_online_5734I000000blLR"
         style="display: none; border: 0px none; cursor: pointer"
         onclick="liveagent.startChat('5734I000000blLR')"
         src="/wp-content/themes/zota/img/online.png"/>
      <img
      id="liveagent_button_offline_5734I000000blLR" style="display: none; border: 0px none; "
      src="/wp-content/themes/zota/img/offline.png"/>
    `;
      document.body.appendChild(chat);

      return () => {
        document.body.removeChild(script);
        document.body.removeChild(chat);
        document.getElementById('scriptID')?.remove();
        document.getElementById('chatID')?.remove();
        // document.body.removeChild(secondScript)
        // document.body.removeChild(thirdScript)
        // document.body.removeChild(fourthScript)

      };
    } else if (!onMobile && activateChat) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'scriptID';
      script.innerHTML = `
      window.__lc = window.__lc || {};
      window.__lc.license = 6869171;
      (function () {
        var lc = document.createElement('script');
        lc.type = 'text/javascript';
        lc.async = true;
        lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(lc, s);
      })();
    `;
      document.body.appendChild(script);

      const chat = document.createElement('div');
      chat.className = 'new_chat';
      chat.id = 'chatID';
      chat.innerHTML = `
      <img id="liveagent_button_online_5734I000000blLR"
         style="display: none; border: 0px none; cursor: pointer"
         onclick="liveagent.startChat('5734I000000blLR')"
         src="/wp-content/themes/zota/img/online.png"/>
      <img
      id="liveagent_button_offline_5734I000000blLR" style="display: none; border: 0px none; "
      src="/wp-content/themes/zota/img/offline.png"/>
    `;
      document.body.appendChild(chat);

      return () => {
        document.body.removeChild(script);
        document.body.removeChild(chat);
        document.getElementById('scriptID')?.remove();
        document.getElementById('chatID')?.remove();
      };
    } else {
      return
    }

  }, [onMobile, activateChat]);

  return (
    <Layout>
      <div className="thank-you-page">

        <div className="thank-you-page-right-mobile">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/man-dancing.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/man-dancing.png`}
          />
        </div>

        <div className="thank-you-page-left">
          <div className="main-title">Thank you!</div>
          <div className="secondary-title">{title}</div>

          {wizardStorage.data.approvedProposal === 'approved'
            ?
            <div className='download-btn'>
              <ButtonDownload
                title='Download as PDF'
                onClick={() => console.log('Download PDF')}
              />
            </div>
            :
            null
          }

          <div className='thank-you-page-buttons'>

            <ButtonCTA
              url='https://zotapay.com/schedule-meeting/#step-0'
              title="Schedule a meeting"
            />
            <ButtonCTA
              // url='https://zotapay.com'
              title="Live chat"
              onClick={() => setActivateChat(true)}
            />
          </div>

          <div className="thank-you-icons">
            <SocialIcon
              icon={<EmailIcon/>}
              url="mailto:sales@zotapay.com"
            />
            <SocialIcon
              icon={<InstagramIcon/>}
              url="https://www.instagram.com/zotapay/"
            />
            <SocialIcon
              icon={<FacebookIcon/>}
              url="https://www.facebook.com/zotapay/"
            />
            <SocialIcon
              icon={<TwitterIcon/>}
              url="https://twitter.com/zotapay"
            />
            <SocialIcon
              icon={<LinkedInIcon/>}
              url="https://www.linkedin.com/company/zotapay/"
            />
            <SocialIcon
              icon={<WhatsAppIcon/>}
              url="tel:+85260853817"
            />
          </div>
        </div>

        <div className="thank-you-page-right">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/man-dancing.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/man-dancing.png`}
          />
        </div>

      </div>
    </Layout>
  );
};
